export const OPERATION_TYPES = Object.freeze({
  LOADING: "loading",
  DISCHARGING: "discharging",
});

export const isOperationType = (value) =>
  Object.values(OPERATION_TYPES).includes(value);
